import ApiBase from './base/ApiBase';

export interface AssessmentPublicationReplayItem { Id: string; Title: string; Description: string; }
export interface AssessmentPublicationReplayEvent { Date: string; Title: string; Description: string; }
export interface AssessmentPublicationReplay {
    OrganizationId: string;
    OrganizationName: string;
    TalentName: string;
    TemplateName: string;
    OverallScore: number;
    AdjustedScore: number;
    Events: AssessmentPublicationReplayEvent[];
    DevelopmentItems: AssessmentPublicationReplayItem[];
    ImprovementItems: AssessmentPublicationReplayItem[];
    FinalDevelopmentAction: AssessmentPublicationReplayItem;
}

export default class AssessmentPublicationReplayClient extends ApiBase {
    async Get(signal?: AbortSignal): Promise<AssessmentPublicationReplay> {
        return this.GetAsync('Assessment/Replay/Publication', signal);
    }
}
